// extracted by mini-css-extract-plugin
export var textMobile = "block-projects-module--textMobile--1SjoO";